import React from 'react';
import { StyledButton } from '../../Exams/styled';
import { DataGrid } from '@mui/x-data-grid';
import pallet from '../../../layouts/pallet';
import { getAssessmentOverviewColumns } from '../utils/AssessmentOverviewColumns';
import { AssessmentOverviewTableProps } from '../types';
import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel
} from '@mui/material';
import { dataGridSx } from '../../common/styled/DataGrid';
import tableColumnUtils from '../../../utils/tableColumnUtils';
import { PageWrapper } from '../../common/styled';
import CustomDataGridToolbar from '../../common/components/CustomDataGridToolbar';

const AssessmentOverviewTable = ({
  assessmentOverviewData,
  isLoading,
  hasChanges,
  onFinalSaveCheckBoxChange,
  handleToggleEnableEvaluation,
  handleToggleAllEvaluationEnable
}: AssessmentOverviewTableProps) => {
  const columns = getAssessmentOverviewColumns(handleToggleEnableEvaluation);

  const allEnabled =
    assessmentOverviewData.length > 0 &&
    assessmentOverviewData.every((row) => row.enableEvaluation);

  return (
    <PageWrapper sx={{ paddingTop: '16px !important' }}>
      <Box sx={{ alignSelf: 'end' }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={allEnabled}
              onChange={handleToggleAllEvaluationEnable}
            />
          }
          label='Enable All Evaluations'
        />
      </Box>
      <DataGrid
        rowHeight={50}
        rows={assessmentOverviewData}
        columns={columns}
        loading={isLoading}
        showToolbar
        disableColumnSelector
        disableRowSelectionOnClick
        pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
        initialState={{
          ...tableColumnUtils.DATA_GRID_INITIAL_STATE,
          columns: {
            ...columns,
            columnVisibilityModel: { id: false }
          }
        }}
        slots={{ toolbar: CustomDataGridToolbar }}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
      <StyledButton
        onClick={onFinalSaveCheckBoxChange}
        disabled={!hasChanges || isLoading}
        sx={{ width: 'max-content', alignSelf: 'flex-end' }}
      >
        {isLoading ? (
          <CircularProgress size={24} color='inherit' />
        ) : (
          'Save Changes'
        )}
      </StyledButton>
    </PageWrapper>
  );
};

export default AssessmentOverviewTable;
